import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import GitHubIcon from '@mui/icons-material/GitHub';
// import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import HeaderNano from '../../components/shared/SeoHeader';
// import Header from './Header';
import MainFeaturedPost from './MainFeaturedPost';
import Main from './Main';
import Sidebar from './Sidebar';
import Footer from '../Layouts/footer';
import post1 from './Resoning.md';
import post2 from './blog-post.2.md';
import post3 from './wpp.md';
import Spacer from '../../components/Agent/Spacer';
import FooterLight from '../../components/shared/SeoFooter';

//color button styles - starts
import {styled} from '@mui/material/styles';
import {purple} from '@mui/material/colors';
import Button from '@mui/material/Button';
//color button styles - ends

import {
  faLinkedin,
  faTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { logger } from '../../utils/logger';

const sxStyles = {
  mainGrid: {
    marginTop: '24px',
  },
};

const sections = [
  {title: 'Reasoning With Time', url: '#'},
  {title: 'Design', url: '#'},
  {title: 'Culture', url: '#'},
  {title: 'Business', url: '#'},
  {title: 'Politics', url: '#'},
  {title: 'Opinion', url: '#'},
  {title: 'Science', url: '#'},
  {title: 'Health', url: '#'},
  {title: 'Style', url: '#'},
  {title: 'Travel', url: '#'},
];

const mainFeaturedPost = {
  title: 'Reasoning With AI',
  description:
    'Reasoning is the most important aspect of AI which makes it looks like Magic and the magic is here at HertzAI. We are building models to reason and answer from knowledge graphs which gets updated and continually learnt.',
  image: '/HevolveBanner.webp',
  imgText: 'Reasoning with AI description',
  linkText: 'Continue reading…',
};


// const posts = [post1, post2, post3];
const posts = [post1, post2, post3];

const sidebar = {
  title: 'About',
  description:
    'Hevolve redefines the learning experience by giving a multimodal interaction with conversational AI bot as teacher sourcing raw knowledge directly from books, internet, videos. Our mission is to make teaching transcend current human boundaries creating a fully autonomous AI system with superhuman teaching capabilities which understands every individual creating tailored dynamic curriculum, with teaching, assessment and revision flows in unbiased fashion.',
  archives: [
    ],
  social: [
    {
      name: 'Youtube',
      icon: faYoutube,
      link: 'https://www.youtube.com/channel/UClzFvo8SECdyd0dVQhJ2Cbg',
    },
    {
      name: 'Linkedin',
      icon: faLinkedin,
      link: 'https://www.linkedin.com/company/hertz-ai/',
    },
    {
      name: 'Twitter',
      icon: faTwitter,
      link: 'https://twitter.com/AiHertz?s=20',
    },
  ],
};

const ColorButton = styled(Button)(({theme}) => ({
  color: theme.palette.getContrastText(purple[500]),
  background: 'linear-gradient(to right, #00e89d, #0078ff)',
  '&:hover': {
    backgroundColor: purple[700],
  },
}));

export default function ReasonAiBlog() {
  const [posts, setPosts] = React.useState([]);

  React.useEffect(() => {
    logger.log('Blog is fully loaded');
    //getAllAssessmentNames();
    fetch(post1)
      .then((res) => res.text())
      .then((postContent) => setPosts([postContent]))
      .catch((err) => console.error(err));
  }, []);

  return (
    <React.Fragment>
      <HeaderNano />
      <Container maxWidth="lg">
        {/* <Header title="Blog" sections={sections} /> */}
        <main>
          <MainFeaturedPost post={mainFeaturedPost} />
          {/* <Grid container spacing={4}>
            
          </Grid> */}
          <Grid container spacing={5} sx={sxStyles.mainGrid}>
            <Main
              title="Reasoning With AI"
              posts={posts}
              discoverMore="block"
            />
            <Sidebar
              title={sidebar.title}
              description={sidebar.description}
              archives={sidebar.archives}
              social={sidebar.social}
            />
          </Grid>
        </main>
      </Container>
      <Spacer h={120} />
      <FooterLight />
      {/* <Footer /> */}
    </React.Fragment>
  );
}
